"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundPrecision = void 0;
var roundPrecision = function (roundedNumber, precision) {
    if (precision === void 0) { precision = 2; }
    roundedNumber *= Math.pow(10, precision);
    roundedNumber = Math.round(roundedNumber);
    roundedNumber /= Math.pow(10, precision);
    return roundedNumber;
};
exports.roundPrecision = roundPrecision;
exports.default = {};
//# sourceMappingURL=math.js.map